// app/javascript/controllers/search_affiliates_controller.js
import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

export default class extends Controller {
  static targets = ["query", "results", "hidden"];
  static values = { url: String };

  connect() {
    this.debouncedSearch = debounce(this._search.bind(this), 300);
  }

  search(event) {
    this.hiddenTarget.value = "";
    this.debouncedSearch(event);
  }

  async _search(event) {
    const query = event.target.value.trim();

    if (query.length < 2) {
      this.hideResults();
      return;
    }

    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("query", query);

    try {
      const response = await fetch(url.toString());
      const html = await response.text();

      if (html.trim() === "") {
        this.showNoResults();
      } else {
        this.resultsTarget.innerHTML = html;
        this.showResults();
      }
    } catch (error) {
      console.error("Search error:", error);
      this.hideResults();
    }
  }

  choose(event) {
    const id   = event.currentTarget.dataset.id;
    const name = event.currentTarget.dataset.name;

    this.hiddenTarget.value = id;
    this.queryTarget.value  = name;

    this.hideResults();
  }

  showResults() {
    this.resultsTarget.classList.add("show");
  }

  hideResults() {
    this.resultsTarget.classList.remove("show");
    this.resultsTarget.innerHTML = "";
  }

  showNoResults() {
    this.resultsTarget.innerHTML = '<div class="dropdown-item disabled text-muted" role="option" aria-disabled="true">No affiliates found</div>';
    this.showResults();
  }
}
